import React from 'react'

const ConnOffingoBusiness = () => {
    return (
        <div>ConnOffingoBusiness</div>
    )
}

export default ConnOffingoBusiness